module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAYCAYAAADH2bwQAAAAR0lEQVQoke3KsQ2AIAAAwYMZoGAk58C1XIZdFMewMzEhVJZ8ex9ayhsOFN86amgpXwN8pzhBKHGCYA1r+H/oE78jdtwDPFEfRXkKyfNTE4cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title.png
// module id = 05xs
// module chunks = 1